module.exports = __webpack_public_path__ + "static/img/view-product-icon.8c8a70a0.png";